export function getEnv() {
  const env = {
    GOOGLE_PAY_INIT_ENVIRONMENT: process.env.NEXT_PUBLIC_GOOGLE_PAY_INIT_ENVIRONMENT,
    PAYMENT_PAYPAL_CLIENT_ID: process.env.NEXT_PUBLIC_PAYMENT_PAYPAL_CLIENT_ID,
  };

  return env;
}
